export interface DatasourceBrowserSearch {
    tab?: string;
    view?: string;
    field?: string;
    value?: string;
    asset?: string;
    overlay?: string;
    page?: string;
    gridPage?: string;
}

const asOptionalString = (value: unknown): string | undefined =>
    typeof value === "string" && value.length > 0 ? value : undefined;

export const validateBrowserSearch = (
    search: Record<string, unknown>,
): DatasourceBrowserSearch => ({
    tab: asOptionalString(search.tab),
    view: asOptionalString(search.view),
    field: asOptionalString(search.field),
    value: asOptionalString(search.value),
    asset: asOptionalString(search.asset),
    overlay: asOptionalString(search.overlay),
    page: asOptionalString(search.page),
    gridPage: asOptionalString(search.gridPage),
});
